import axiosApi from '../api/axiosApi';
import { GET_STATISTICS } from '../common/constants/constants';
import { StatisticsRequest } from '../common/types/types';

class StatisticsService {
  getStatistics(request: StatisticsRequest) {
    return axiosApi.post(GET_STATISTICS, request);
  }
}

export default new StatisticsService();
